/* ===================================================
   VERSION SELECTOR - Sliding Pill controller
   Coordinates the Fan/Player toggle with the existing
   variant matcher in main-product.liquid via the hidden
   .vs-hidden-fieldset and window._shopUpdateProduct.
   =================================================== */
(function () {
  'use strict';

  const STORAGE_PREFIX = 'fbc:vs:';

  function initAll() {
    document.querySelectorAll('[data-version-selector]').forEach(init);
  }

  function init(root) {
    if (root.dataset.vsInit === '1') return;
    root.dataset.vsInit = '1';

    const fanValue = root.dataset.fanValue;
    const playerValue = root.dataset.playerValue;
    const optionName = root.dataset.optionName;
    const pill = root.querySelector('[data-vs-pill]');
    const opts = root.querySelectorAll('[data-vs-value]');
    const radios = root.querySelectorAll('[data-vs-radio]');

    if (!pill || opts.length === 0 || radios.length === 0) return;

    const storageKey = STORAGE_PREFIX + (window.location.pathname || '') + ':' + optionName;

    // Determine initial selection: URL variant (already reflected in root.dataset.selected
    // via Shopify's selected_or_first_available_variant) → sessionStorage → fan default.
    let initial = root.dataset.selected || '';
    try {
      const stored = sessionStorage.getItem(storageKey);
      // Only restore from storage if there's no explicit URL-driven selection upstream.
      // If a Player variant is in the URL (?variant=), root.dataset.selected reflects that
      // and we respect it. Otherwise prefer the stored value.
      const urlHasVariant = new URL(window.location.href).searchParams.has('variant');
      if (!urlHasVariant && stored && (stored === fanValue || stored === playerValue)) {
        initial = stored;
      }
    } catch (e) { /* sessionStorage disabled - ignore */ }

    if (initial !== fanValue && initial !== playerValue) {
      initial = fanValue;
    }

    setSelection(initial, /*triggerUpdate*/ false);

    // Click + keyboard activation
    opts.forEach((opt) => {
      opt.addEventListener('click', () => {
        select(opt.dataset.vsValue);
      });
      opt.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.key === 'ArrowUp' || e.key === 'ArrowDown') {
          e.preventDefault();
          const arr = Array.from(opts);
          const idx = arr.indexOf(opt);
          const next = arr[(idx + 1) % arr.length];
          next.focus();
          select(next.dataset.vsValue);
        } else if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          select(opt.dataset.vsValue);
        }
      });
    });

    function select(value) {
      setSelection(value, true);
    }

    // Submit-time guarantee: override input[name="id"] with the correct variant just
    // before the form submits - handles stale hiddenInput refs and app (Optionize/qikify) overrides.
    const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
    if (productForm && !productForm.dataset.vsSubmitGuard) {
      productForm.dataset.vsSubmitGuard = '1';
      productForm.addEventListener('submit', function () {
        const variants = window._vsProductVariants;
        if (!variants) return;
        const selectedOptions = [];
        document.querySelectorAll('.variant-picker__fieldset').forEach(function (fs) {
          const checked = fs.querySelector('input[type="radio"]:checked');
          if (checked) selectedOptions.push(checked.value);
        });
        const match = variants.find(function (v) {
          return selectedOptions.every(function (opt, i) { return v.options[i] === opt; });
        });
        if (match) {
          const inp = productForm.querySelector('input[name="id"]');
          if (inp) inp.value = match.id;
        }
      }, false);
    }

    // Info popover
    const infoBtn = root.querySelector('.version-selector__info');
    const popover = root.querySelector('.vs-popover');
    if (infoBtn && popover) {
      const isMouseDevice = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      function openPopover() {
        popover.classList.add('vs-popover--open');
        infoBtn.setAttribute('aria-expanded', 'true');
        popover.setAttribute('aria-hidden', 'false');
      }
      function closePopover() {
        popover.classList.remove('vs-popover--open');
        infoBtn.setAttribute('aria-expanded', 'false');
        popover.setAttribute('aria-hidden', 'true');
      }

      if (isMouseDevice) {
        const wrap = infoBtn.closest('.vs-info-wrap');
        wrap.addEventListener('mouseenter', openPopover);
        wrap.addEventListener('mouseleave', closePopover);
        infoBtn.addEventListener('click', function () {
          popover.classList.contains('vs-popover--open') ? closePopover() : openPopover();
        });
      } else {
        infoBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          popover.classList.contains('vs-popover--open') ? closePopover() : openPopover();
        });
        document.addEventListener('click', function (e) {
          if (!root.contains(e.target)) closePopover();
        });
      }

      infoBtn.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closePopover();
      });
    }

    function setSelection(value, triggerUpdate) {
      const isPlayer = value === playerValue;
      const key = isPlayer ? 'player' : 'fan';

      // Update visual state
      pill.dataset.active = key;
      opts.forEach((o) => {
        const matches = o.dataset.vsValue === value;
        o.setAttribute('aria-checked', matches ? 'true' : 'false');
        o.setAttribute('tabindex', matches ? '0' : '-1');
      });

      // Update hidden radio (drives variant matching)
      radios.forEach((r) => { r.checked = (r.dataset.vsRadio === value); });

      // Notify apps (Optionize, qikify) that גרסה changed via native DOM event
      const checkedRadio = root.querySelector('[data-vs-radio="' + value + '"]');
      if (checkedRadio) checkedRadio.dispatchEvent(new Event('change', { bubbles: true }));

      // Persist
      try { sessionStorage.setItem(storageKey, value); } catch (e) { /* ignore */ }

      // Trigger price/variant recalculation
      if (triggerUpdate && typeof window._shopUpdateProduct === 'function') {
        window._shopUpdateProduct();
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
